// extracted by mini-css-extract-plugin
export default {"badgesList":"Badges_badgesList__BasjN","listItem":"Badges_listItem__TYHmK","button":"Badges_button__6yKIv"};